/**
 * PWA app-icon badge helper (navigator.setAppBadge / clearAppBadge).
 * Supported on Chrome/Edge desktop + installed PWA on iOS 16.4+.
 * No-op on unsupported browsers.
 */

export function setAppBadge(count) {
  try {
    if ('setAppBadge' in navigator) {
      if (count && count > 0) {
        navigator.setAppBadge(count).catch((e) => {
          if (process.env.NODE_ENV !== 'production') console.debug('[appBadge] setAppBadge:', e?.message);
        });
      } else {
        navigator.clearAppBadge?.().catch((e) => {
          if (process.env.NODE_ENV !== 'production') console.debug('[appBadge] clearAppBadge:', e?.message);
        });
      }
    }
  } catch (e) {
    if (process.env.NODE_ENV !== 'production') console.debug('[appBadge] setAppBadge outer:', e?.message);
  }
}

export function clearAppBadge() {
  try {
    if ('clearAppBadge' in navigator) {
      navigator.clearAppBadge().catch((e) => {
        if (process.env.NODE_ENV !== 'production') console.debug('[appBadge] clearAppBadge:', e?.message);
      });
    }
  } catch (e) {
    if (process.env.NODE_ENV !== 'production') console.debug('[appBadge] clearAppBadge outer:', e?.message);
  }
}
